import _ from 'lodash';
import BasePage from '../pages/BasePage';
import DeviceDetector from './DeviceDetector';
import MessageBusTopics from '../../common/MessageBusTopics';
import ModelComposer from './ModelComposer';
import PageCommon from '../pages/PageCommon';
import SelectionViewAdapter from '../views/SelectionViewAdapter';
import URLProvider from './URLProvider';

var containerSelector = '#topBetsFragmentContainer';
var deniedPages = ['top-bets', 'virtual'];
var widgetModel;

/**
 * Callback to execute when page change event is fired;
 * Depending on the context it loads the topbets fragment or clears old container
 *
 * @returns {void}
 *
 * @private
 */
var onPageChanged = function onPageChanged() {
 
    if (pageIsDenied(window.WH.sportsbook.page)) {

        clearTopBetsContent();
    } else {

        loadTopBetsFragment();
    }
};

/**
 * Does an AJAX call to fetch the fragment for a sport and inserts it into the DOM
 *
 * @returns {void}
 *
 * @private
 */
var loadTopBetsFragment = function loadTopBetsFragment() {

    var fragmentURL = URLProvider.topBets.topBetsFragment({
        locale: window.WH.sportsbook.lang,
        sport: window.WH.sportsbook.sportEn,
    });

    // reload the snippet and set the url and history
    PageCommon.reloadSnippet({
        'requestURL': fragmentURL,
    }, containerSelector, {
        'afterSuccess': onTopBetFragmentLoaded,
        'afterError': onTopBetFragmentError,
    });
};


/**
 * Executed after a successful fragment fetch
 *
 * @returns {void}
 *
 * @private
 */
var onTopBetFragmentLoaded = function postLoad() {

    ModelComposer.generateMergedModel(window.WH.sportsbook.model);

    unSubscribeFromOldPushUpdates();
    subscribeToPushUpdates();
    formatDatesAndOdds();
};

/**
 * Executed in case of an error during top bets fragment fetching
 *
 * @returns {void}
 *
 * @private
 */
var onTopBetFragmentError = function onTopBetFragmentError() {

    clearTopBetsContent();
};

/**
 * Removes old top bets fragment and unsubscribes from push updates
 *
 * @returns {void}
 *
 * @private
 */
var clearTopBetsContent = function clearTopBetsContent() {

    unSubscribeFromOldPushUpdates();
    BasePage.jQuery(containerSelector).empty();
};

/**
 * Executed when page model is rebuilt
 *
 * @param {String} eventName - name of dispatched event
 * @param {String} preGenerateMergedModel - fragment model before merging to the main page model
 *
 * @returns {void}
 *
 * @private
 */
var setWidgetModel = function (eventName, preGenerateMergedModel) {

    widgetModel = preGenerateMergedModel && preGenerateMergedModel.topBetsWidget;
};

/**
 * Helper to check if the page should have the top bets fragment
 *
 * @param {String} page - the current page
 * @returns {Boolean}
 *
 * @private
 */
var pageIsDenied = function pageIsDenied(page) {

    return _.some(deniedPages, function (deniedPage) {
        return deniedPage === page;
    });
};

/**
 * Helper to format dates and odds after fragment reload
 *
 * @returns {void}
 *
 * @private
 */
var formatDatesAndOdds = function formatDatesAndOdds() {

    SelectionViewAdapter.init();
    PageCommon.oddsConvert();
};

/**
 * Unsubscribes the items that have been removed from the page from push updates
 *
 * @returns {void}
 *
 * @private
 */
var unSubscribeFromOldPushUpdates = function unSubscribeFromOldPushUpdates() {

    if (widgetModel && widgetModel.events) {

        ModelComposer.removeEventsFromModel(widgetModel.events);
    }
};

/**
 * Subscribes top bets items to push updates
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToPushUpdates = function subscribeToPushUpdates() {

    if (widgetModel) {

        _.each(widgetModel, subscribeSetToPush);
        BasePage.ModelComposer.regenerateMergedModel(window.WH.sportsbook.model);
    }
};

/**
 * Subscribe a set of entities (events, markets, etc)
 * to PUSH updates
 *
 * @param   {Object} set An object containing entities
 *                       such as markets, selections, events
 *
 * @returns {void}
 *
 * @private
 */
var subscribeSetToPush = function (set) {

    _.each(set, subscribeEntityToPush);
};

/**
 * Subscribe a single entity to PUSH updates
 *
 * @param   {Object} entity Market/event/selection model
 *
 * @returns {void}
 *
 * @private
 */
var subscribeEntityToPush = function (entity) {

    if (entity && entity.id && BasePage.PageCommon.DomPushAdapter.subscribe(entity)) {

        BasePage.PageCommon.PushAdapter.subscribe(entity.pdsTopic);
    }
};

/**
 * Subscribe to a page change event when in desktop
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToPageChange = function subscribeToPageChange() {

    // The topbets in their own fragment will be reloaded only in desktop
    if (DeviceDetector.isDesktop()) {

        window.WH.messageBus.subscribe(MessageBusTopics.NAVIGATION_PAGE_CHANGED, onPageChanged);
        window.WH.messageBus.subscribe(MessageBusTopics.MODEL_COMPOSER_PREGENERATE_MERGED_MODEL, setWidgetModel);
    }
};


/**
 * Helper function to allow mocking dependencies in the UT
 *
 * @returns {Object}
 *
 * @public
 */
var getDependencies = function getDependencies() {

    return {
        URLProvider: URLProvider,
        PageCommon: PageCommon,
        BasePage: BasePage,
        DeviceDetector: DeviceDetector,
        ModelComposer: ModelComposer,
    };
};

/**
 * Component's entry point, should be called to do the initialization
 *
 * @returns {void}
 *
 * @public
 */
var init = function init() {
    subscribeToPageChange();
};

/**
 * API returned by the component
 *
 * @returns {Object}
 *
 * @public
 */
export default {
    getDependencies: getDependencies,
    init: init,
};
